import Box from "@mui/material/Box";
import type { ReactNode } from "react";

export function Surface({ children, sx }: { children: ReactNode; sx?: object }) {
  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        border: "1px solid #d0d5dd",
        borderRadius: "2px",
        p: 2.5,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
